module.exports = __webpack_public_path__ + "7e08fba7aba33c35ea0b74672e61ea2a.jpg";